import { render } from "./LoginPage.vue?vue&type=template&id=1ac8f84c&scoped=true&bindings={}"
import script from "./LoginPage.vue?vue&type=script&lang=ts"
export * from "./LoginPage.vue?vue&type=script&lang=ts"

import "./LoginPage.vue?vue&type=style&index=0&id=1ac8f84c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1ac8f84c"

export default script